import HeroSection from '@/pages/home/components/HeroSection';
import QuickEntrySection from '@/pages/home/components/QuickEntrySection';
import CategorySection from '@/pages/home/components/CategorySection';
import ZonesSection from '@/pages/home/components/ZonesSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import GuidePreviewSection from '@/pages/home/components/GuidePreviewSection';
import FaqSection from '@/pages/home/components/FaqSection';
import VoiceSection from '@/pages/home/components/VoiceSection';
import { useSeo } from '@/hooks/useSeo';

const SITE_URL = 'https://hnbhcpa.cn';

export default function HomePage() {
  useSeo({
    title: '爆料专区首页入口_网址网页站点导航 - 爆料专区雷达',
    description:
      '爆料专区导航站：整理爆料专区首页、入口、网址、网页、站点访问路径，直达热门讨论区与最新爆料帖，附访问指南与常见问题，收藏即用。',
    keywords: '爆料专区,爆料专区首页,爆料专区入口,爆料专区网址,爆料专区网页,爆料专区站点',
    path: '/',
    schema: [
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: '爆料专区导航',
        url: `${SITE_URL}/`,
        description: '爆料专区首页入口、网址网页与热门讨论区导航站。',
        potentialAction: {
          '@type': 'SearchAction',
          target: `${SITE_URL}/topics?q={search_term_string}`,
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: '爆料专区导航',
        url: `${SITE_URL}/`,
        email: 'contact@baoliao-nav.example.com',
        description: '信息整理与访问导航站点，帮助用户快速找到爆料专区入口与讨论区。',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: '爆料专区首页入口与网址网页站点导航',
        url: `${SITE_URL}/`,
        inLanguage: 'zh-CN',
      },
    ],
  });

  return (
    <main>
      <HeroSection />
      <QuickEntrySection />
      <CategorySection />
      <ZonesSection />
      <TopicsSection />
      <GuidePreviewSection />
      <FaqSection />
      <VoiceSection />
    </main>
  );
}